import { RouteObject } from 'react-router';

import { AdminsPageLazy } from './page.tsx';

import { RoleProtectedRoute } from '@/services/roles';
import { EAdminRoutes } from '@/services/router/enums';

export const ADMINS_ROUTE: RouteObject = {
    path: EAdminRoutes.Admins,
    element: (
        <RoleProtectedRoute path={EAdminRoutes.Admins}>
            <AdminsPageLazy />
        </RoleProtectedRoute>
    ),
};
